import { render, staticRenderFns } from "./MissingGoods.vue?vue&type=template&id=ca8794c6&"
import script from "./MissingGoods.vue?vue&type=script&lang=js&"
export * from "./MissingGoods.vue?vue&type=script&lang=js&"
import style0 from "./MissingGoods.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./MissingGoods.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports